<template>

    <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">

        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasNavbarLabel">{{ __('Hauptmenü') }}</h5>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>

        <div class="offcanvas-body">
            <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
                <li class="nav-item dropdown border-bottom" v-for="item in items">

                    <inertia-link class="nav-link d-flex py-3 justify-content-between"
                                  role="button"
                                  :data-bs-toggle="item.children.length ? 'dropdown': ''" 
                                  aria-expanded="false"
                                  :href="item.permalink">
                        <span>
                            {{ item.name }}
                        </span>
                        <span v-if="item.children.length">
                            <i class="bi bi-chevron-right"></i>
                        </span>
                    </inertia-link>

                    <ul class="dropdown-menu border-0 bg-light"
                        v-if="item.children.length">
                        <li>
                            <inertia-link class="dropdown-item fw-bold"
                                          :href="item.permalink"
                                          :title="item.name">
                                {{ item.name }}
                            </inertia-link>
                        </li>
                        <li v-for="child in item.children">
                            <inertia-link class="dropdown-item"
                                          :href="child.permalink"
                                          :title="child.name">
                                {{ child.name }}
                            </inertia-link>
                        </li>
                    </ul>

                </li>
            </ul>
        </div>

    </div>

</template>


<script>
    export default {
        props: [
//            'items'
        ],
        components: {
        },
        data() {
            return {
                items: window._mainCategories,
            }
        },
        mounted() {
            this.$inertia.on('start', (event) => {

                var myOffcanvas = document.getElementById('offcanvasNavbar');
                var bsOffcanvas = bootstrap.Offcanvas.getOrCreateInstance(myOffcanvas);

                if (myOffcanvas.classList.contains('show')) {
                    console.log('Closing offcanvas menu.');
                    bsOffcanvas.hide();
                }
            })
        },
    }
</script>